export default {
    methods: {
        formatDate(date){
            return moment.utc(date).local().format('DD/MM/YYYY');
        }
    }
};